module.exports = __webpack_public_path__ + "static/img/gongan_logo.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/gongan_logo.png
// module id = m8i/
// module chunks = 1